module.exports = __webpack_public_path__ + "media/images/sp/calendar/off-38f140edddb456f4a06d3ea9e2beb167.svg";